import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState }  from "react";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';


export default function Expenses(){
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const refcontainer = useRef(null);
    const [loanstatus,setLoanstatus]= useState([]);
    const [dialogNo,setDialogNo] = useState(0);
    const date = new Date().toISOString().slice(0,10);
    const userid = parseInt(localStorage.getItem("userid")) ;
    const user = parseInt(localStorage.getItem("utype")) ;
    const [expensehead, setExpensehead] = useState([]);
    const [expenseid, setExpenseid] = useState([]);
    const [settings, setSettings] = useState([]);
    const [account, setAccount] = useState([]);
    const[checked,setChecked] = useState(false);
    const[sign,setSign] = useState('+');
    const way = '/home';


    useEffect(() => 
    {

     fetch(API_URL+"api/Userloan/GetLoanStatus?userid="+userid)
    .then(response => response.json())
    .then(data => {setLoanstatus(data)});

    fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
    .then(res=>res.json())
    .then((data)=>{setSettings(data)})

    fetch(API_URL+"api/Expense/GetExpenseHead")
    .then(response => response.json())
    .then(data => {setExpensehead(data)});

    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});
  
  
    },[])

function createexpense(){
        var expensenum = settings[0].ExpenseID + 1;
        var edate = document.getElementById('edate').value;
        var ehead = document.getElementById('ehead').value;
        var desc = document.getElementById('edesc').value;
        var eamount= document.getElementById('eamount').value;
        var commonid = settings[0].CommonID + 1;

        const expense = new FormData();
        expense.append("expenseid",expensenum);
        expense.append("edate",edate);
        expense.append("ehead",ehead);
        expense.append("desc",desc);
        expense.append("eamount",eamount);
        expense.append("userid",userid);
        expense.append("commonid",commonid)
        
       

    if (loanstatus.length !== 0 )
    {
      if(loanstatus[0].LoanReturned === 1)
      {
        setDialogNo(1);
        showOKdialog();
      }
      else if(date < loanstatus[0].EntryDate.slice(0,10))
      {
        setDialogNo(2);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) > date)
      {
        setDialogNo(3);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) < date)
      {
        setDialogNo(4);
        showOKdialog();
      }
      else
      {
        setDialogNo(5);
        fetch(API_URL+"api/Expense/CreateExpense",{method:"POST",body:expense}).then(res=>res.json())
        .then(()=>{});

        fetch(API_URL+"api/Expense/IncrementExpenseID?id="+expensenum,{method:"PUT",body:null}).then(res=>res.json())
        .then(()=>{});
          
        showOKdialog();
      }
    }
    else
    {
      setDialogNo(6);
      showOKdialog();
    }
}

function ledgerentry()
    {
  
    const amount =parseFloat(document.getElementById('eamount').value);
    
    var transid = settings[0].AccTransID + 1;
    const commonid = settings[0].CommonID + 1

    const expenseaccount = account.filter((e)=>{if(e.AccountID === 8){return e;}})
    const expenseaccbalance = (expenseaccount[0].CurrentDebit+amount) - expenseaccount[0].CurrentCredit;

    
    
    const cashaccountdata = new FormData();
    cashaccountdata.append("entrydate",date);
    cashaccountdata.append("accountdate",date)
    cashaccountdata.append("accountid",expenseaccount[0].AccountID)
    cashaccountdata.append("description", "By Cash Account ExpenseID:  " + (settings[0].ExpenseID + 1) );
    cashaccountdata.append("refnumber",("E.NO "+(settings[0].ExpenseID + 1)));
    cashaccountdata.append("vouchertype",1);
    cashaccountdata.append("vouchernum",1);
    cashaccountdata.append("dramount",amount);
    cashaccountdata.append("cramount",0);
    cashaccountdata.append("balance",expenseaccbalance);
    cashaccountdata.append("transid",transid);
    cashaccountdata.append("commonid",commonid);
    cashaccountdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:cashaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+expenseaccount[0].AccountID+"&amount="+(expenseaccount[0].CurrentDebit+amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    
    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    const cashbalance = cashaccount[0].CurrentDebit-(cashaccount[0].CurrentCredit+amount);
    transid = transid + 1;

    cashaccountdata.set("accountid",cashaccount[0].AccountID);
    cashaccountdata.set("balance",cashbalance);
    cashaccountdata.set("dramount",0);
    cashaccountdata.set("cramount",amount);
    cashaccountdata.set("transid",transid);
    cashaccountdata.set("description", "To Expense Account ExpenseID:  " + (settings[0].ExpenseID + 1) );

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:cashaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentCredit+amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});
    
    fetch(API_URL+"api/Ledger/UpdateAccTransID?id="+transid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCommonID?id="+commonid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});

}

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}


    return (
        <>
        <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
             paddingTop:"10px", top :"0px", position:"relative", fontFamily:"sans-serif",
             fontSize:"18px",marginBottom:"10%"}}> 
             Expenses
             <Navbar/>
        </div> 
               
        {user === 1 ? <>
        <button type="button" style={{width:"25px",height:"25px",marginLeft:"60%", fontSize:"20px",marginBottom:"-20px"}} onClick={()=>{navigate('/addexpensehead')}}>{sign}<label style={{marginLeft:"15px",fontSize:"20px"}}>New_Head</label></button><br/>
        </>
        :
        <></>}
        <label for="edate"style = {{marginLeft:"1%"}}>Date</label> 
        <input id ="edate" type="date" defaultValue ={new Date().toISOString().slice(0,10)} style = {{height:"30px",width:"96%",marginLeft:"1%",marginBottom:"20px"}}></input><br/>
        <label for="ehead"style = {{marginLeft:"1%"}}>Choose Expense head</label><br/>
        <select id="ehead" style = {{height:"35px",width:"96.5%",marginLeft:"1%",marginBottom:"20px"}}>
        {expensehead.map(exp => {return(<option>{exp.ExpensesHeadName}</option>) })}
        </select>
        <label for="edesc"style = {{marginLeft:"1%"}}>Expense Description</label><br/>
        <input id="edesc"style = {{height:"30px",width:"96%",marginLeft:"1%",marginBottom:"20px"}}></input><br/>
        <label for="eamount"style = {{marginLeft:"1%"}}>Expense Amount </label><br/>
        <input id ="eamount"style = {{height:"30px",width:"96%",marginLeft:"1%",marginBottom:"20px"}}></input><br/>
        <button className="actionbuttons" type="button" onClick={()=>{createexpense()}}>Ok</button>
        <button className="actionbuttons" style ={{backgroundColor:"red"}} type="button" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>Cancel</button>
        
        <dialog id="myDialog" className="okdialog">
            {dialogNo === 1 ? <>
            <p>Expenses Closed For this User ID : {userid}  </p>
            <button className="okdialogbutton" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 2 ? <>
            <p>Please Make Sure, Expenses Date is Correct</p>
            <button className="okdialogbutton" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 3 ? <>
            <p>Sorry! You Can't Make Expenses for Today's Date As Your Day closed</p>
            <button className="okdialogbutton" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 4 ? <>
            <p>Sorry! Please Make Sure Date is Correct</p>
            <button className="okdialogbutton" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 5 ? <>
            <p>Expense Entry Successful</p>
            <button className="okdialogbutton" onClick={()=>{
              if (user === 1 ){ ledgerentry(); navigate('/accounts');}
              else {ledgerentry(); navigate('/home');}}}>OK</button> </> : <></>}
            {dialogNo === 6 ? <>
            <p>Sorry! You Aren't Authorized</p>
            <button className="okdialogbutton" onClick={()=>{user === 1 ? navigate('/accounts') : navigate('/home')}}>OK</button> </> : <></>}
        </dialog> 
        </>
    )
}